import { ContestType } from '@betterpool/api-types/contests-service';

import type { FullContestTeamPickEm } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

import type { SlateWithStateAndSettingsTeam } from '../../team/parsers/parseSlateTeamBase/parseSlateTeamBase';
import parseSlateTeamBase from '../../team/parsers/parseSlateTeamBase/parseSlateTeamBase';

type SlateWithStateAndSettingsTeamPickEm = Omit<SlateWithStateAndSettingsTeam, 'settings'> & {
  contestType: ContestType.TEAM_PICK_EM;
  settings: SlateWithStateAndSettingsTeam['settings'] & {
    isBestPickEnabled?: boolean;
  };
};

const parseTeamPickEmSlates = (
  contest: FullContestTeamPickEm,
  slates: ContestSlate[]
): SlateWithStateAndSettingsTeamPickEm[] =>
  slates.map((slate, index) => {
    const baseSlate = parseSlateTeamBase(contest, slate, index);

    return {
      contestType: ContestType.TEAM_PICK_EM,
      id: baseSlate.id,
      slate: baseSlate.slate,
      state: baseSlate.state,
      settings: {
        ...baseSlate.settings,
        isBestPickEnabled: contest.settings.bestPicks?.[slate.id],
      },
    } satisfies SlateWithStateAndSettingsTeamPickEm;
  });

export default parseTeamPickEmSlates;

export type { SlateWithStateAndSettingsTeamPickEm };
